// Live
const stripe = Stripe('pk_live_kNIekqQHDdnjAyoeikfv8AbC');
console.log('Prod Stripe');
const stripePaymentMethodConfiguration = 'pmc_1RWxneHVI6JyNJXzXyZ0F6Oa';
